import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import InfoIcon from 'resources/UI_ButtonInfo.png';
import { categoryToIcon, categoryToImage, getUniquePrizes } from '../../common';
import Cycler from '../Cycler';
import './Prize.css';

class Prize extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false
    };
  }

  render() {
    const {
      className,
      prizes,
      auctionName,
      auctionDescription,
      durationMs,
      transitionMs,
      openEnabled
    } = this.props;
    const { showModal } = this.state;
    const uniquePrizes = getUniquePrizes(prizes);
    const prizeItems = uniquePrizes.map((item, idx) => (
      <img key={idx} src={categoryToIcon(item)} alt={item.name} />
    ));

    const categoryItems = uniquePrizes.length
      ? uniquePrizes.map((item, idx) => (
          <img
            className="auction-prize-category"
            key={idx}
            src={categoryToImage(item.category)}
            alt={item.category || ''}
          />
        ))
      : prizes.map((item, idx) => (
          <img
            className="auction-prize-category"
            key={idx}
            src={categoryToImage(item.category)}
            alt={item.category || ''}
          />
        ));
    return (
      <div className={`auction-prize ${className || ''}`}>
        <div className="auction-prize-winning">
          <Cycler
            durationMs={durationMs}
            transitionMs={transitionMs}
            items={prizeItems}
          />
        </div>
        <Cycler
          className="auction-prize-category"
          durationMs={durationMs}
          transitionMs={transitionMs}
          items={categoryItems}
        />
        {(prizeItems.length > 1 || openEnabled) && (
          <>
            <button
              className="auction-prize-category auction-prize-info"
              onClick={() => this.setState({ showModal: true })}
              type="button"
            >
              <img src={InfoIcon} alt="Open prizes" />
            </button>
            <Modal
              className="auction-prize-detail"
              show={showModal}
              onHide={() => this.setState({ showModal: false })}
            >
              <Modal.Body>
                <div className="auction-prize-title">{auctionName}</div>
                <div className="auction-prize-description">
                  {auctionDescription}
                </div>
                {prizes.map((item, idx) => (
                  <div
                    className="auction-prize-item"
                    key={`auction-prizes-detail-${idx}`}
                  >
                    <img
                      className="auction-prize-category"
                      src={item.url || categoryToImage(item.category)}
                      alt={item.name || ''}
                    />
                    <div className="auction-prize-name">{item.name}</div>
                  </div>
                ))}
              </Modal.Body>
            </Modal>
          </>
        )}
      </div>
    );
  }
}

Prize.propTypes = {
  duration: PropTypes.number,
  delay: PropTypes.number,
  prizes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
      category: PropTypes.string
    })
  ).isRequired,
  className: PropTypes.string
};

Prize.defaultProps = {
  durationMs: 4000,
  transitionMs: 300
};

export default Prize;
